
import {
  IconUnlock,
  RevDivider,
  RevIllustration,
  RevLink,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './Carriers.translations'

export default {
  components: {
    FormattedMessage,
    IconUnlock,
    RevDivider,
    RevLink,
    RevIllustration,
  },

  props: {
    carriers: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,

    blogLink() {
      return {
        type: 'external',
        href: 'https://help.backmarket.com/hc/en-us/articles/360012437860',
      }
    },

    isSimLocked() {
      return this.carriers.some((carrier) => carrier.isSimLocked)
    },

    shouldDisplayCarriers() {
      return !isEmpty(this.carriers)
    },
  },
}
